export default '7.6.0';